import React from 'react';

const Events = () => {
  return (
    <div className="text-center p-8">
      <h1 className="text-4xl font-bold">Upcoming Events</h1>
      <ul className="mt-6 space-y-4">
        <li className="text-xl">Event 1: Description</li>
        <li className="text-xl">Event 2: Description</li>
        <li className="text-xl">Event 3: Description</li>
      </ul>
    </div>
  );
};

export default Events;
